import script from "./CardWithTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./CardWithTitle.vue?vue&type=script&setup=true&lang=js"

import "./CardWithTitle.vue?vue&type=style&index=0&id=0d2f151c&scoped=true&lang=css"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d2f151c"]])

export default __exports__